<div class="cookie-consent" [class.visible]="visible">
    <div class="cookie-consent__inner">
        <div class="cookie-consent__content">
            <h3 class="cookie-consent__title">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1.004 1.004 0 0 0-1.099-1.249c-.307.044-.613.065-.917.065-2.757 0-5-2.243-5-5 0-.217.031-.444.099-.716a1.001 1.001 0 0 0-1.248-1.098C5.109 .514 2 4.256 2 8.5 2 13.748 6.252 18 11.5 18c4.244 0 7.986-3.109 8.782-7.313a1.003 1.003 0 0 0-.684-1.623zM11.5 16C7.364 16 4 12.636 4 8.5c0-2.708 1.508-5.18 3.847-6.47C7.614 3.012 8.26 4.678 9.526 5.95 10.81 7.24 12.478 7.886 14.47 7.653A5.02 5.02 0 0 0 17 10c0 .171-.014.34-.033.508C18.2 10.168 19.41 9.811 20.5 9.209 19.394 12.999 15.762 16 11.5 16z" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <circle cx="11" cy="13" r="1" />
                    <circle cx="14" cy="10" r="1" />
                </svg>
                {{ 'cookieConsent.title' | translate }}
            </h3>
            <p class="cookie-consent__text">
                {{ 'cookieConsent.textIntro' | translate
                }}<a
                    class="cookie-consent__link"
                    [routerLink]="[ROUTE_CONSTANTS.LEGAL.ROOT, ROUTE_CONSTANTS.LEGAL.PRIVACY]"
                    >{{ 'cookieConsent.privacyPolicy' | translate }}</a
                >{{ 'cookieConsent.textEnd' | translate }}
            </p>
            <div class="cookie-consent__categories">
                <div class="cookie-consent__category cookie-consent__category--required">
                    <label>
                        <input type="checkbox" checked disabled />
                        {{ 'cookieConsent.essential' | translate }}
                        <span class="cookie-consent__badge">{{ 'cookieConsent.required' | translate }}</span>
                    </label>
                </div>
                <div class="cookie-consent__category">
                    <label>
                        <input type="checkbox" [(ngModel)]="analyticsChecked" />
                        {{ 'cookieConsent.analytics' | translate }}
                    </label>
                </div>
                <div class="cookie-consent__category">
                    <label>
                        <input type="checkbox" [(ngModel)]="marketingChecked" />
                        {{ 'cookieConsent.marketing' | translate }}
                    </label>
                </div>
            </div>
        </div>
        <div class="cookie-consent__actions">
            <button class="cookie-consent__btn cookie-consent__btn--accept" (click)="acceptAll()">
                {{ 'cookieConsent.acceptAll' | translate }}
            </button>
            <button class="cookie-consent__btn cookie-consent__btn--save" (click)="savePreferences()">
                {{ 'cookieConsent.savePreferences' | translate }}
            </button>
            <button class="cookie-consent__btn cookie-consent__btn--reject" (click)="rejectAll()">
                {{ 'cookieConsent.rejectAll' | translate }}
            </button>
        </div>
    </div>
</div>
